import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Sections";
import { CALENDLY } from "@/data";

export default function FinalCTA() {
  return (
    <section className="py-24 md:py-32 bg-[#050505] text-[#FDFCF8]" data-testid="final-cta">
      <div className="max-w-[1100px] mx-auto px-5 md:px-10 text-center">
        <Reveal>
          <span className="font-body text-xs font-bold uppercase tracking-[0.25em] text-white/40">Stop guessing</span>
        </Reveal>
        <Reveal i={1}>
          <h2 className="mt-5 font-display text-4xl md:text-6xl font-extrabold tracking-tighter leading-[0.95] mx-auto max-w-[20ch]">
            Ready to find where your money is leaking?
          </h2>
        </Reveal>
        <Reveal i={2}>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#audit"
              data-testid="final-cta-audit-button"
              className="group inline-flex items-center gap-3 rounded-full bg-[#F48220] pl-7 pr-3 py-3 text-black font-body font-semibold hover-lift"
            >
              Get My Free Audit
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-black transition-transform duration-500 group-hover:rotate-45">
                <ArrowUpRight className="h-5 w-5 text-[#F48220]" />
              </span>
            </a>
            <a
              href={CALENDLY}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="final-cta-call-button"
              className="inline-flex items-center gap-2 rounded-full border border-white/20 px-7 py-3.5 font-body font-semibold text-white hover:bg-white hover:text-black transition-colors duration-300"
            >
              Book a 1-on-1 Call
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
